import type { ReactNode } from 'react';

import type { MultiStepFormStepRow } from '#/components/Form/MultiStepForm/MultiStepFormTypes';
import { isDefined } from '#/utils/functional/type';
import { invariant } from '#/utils/invariant';

import { SectionFields_Box_1 } from './SectionFields.styled';

function SectionField({
  field,
  fields,
}: {
  field: string;
  fields: Record<string, ReactNode>;
}) {
  if (!field) {
    return null;
  }

  const f = fields[field];
  invariant(f, `Field with name '${field}' does not exist`);

  // oxlint-disable-next-line react/jsx-no-useless-fragment
  return <>{f}</>;
}

type Props = {
  row: MultiStepFormStepRow;
  fields: Record<string, ReactNode>;
  seenFields: Map<string, number>;
};

export function SectionFields({ row, fields, seenFields }: Props) {
  const { fields: rowFields, columns: rowColumns, noColumns } = row;

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        marginInline: '-8px',
        width: 'calc(100% + 16px)',
      }}
    >
      {rowFields.map((fieldName, fieldIndex, fieldsInRow) => {
        let columns: number | undefined;
        if (noColumns) {
          columns = 1;
        } else if (isDefined(rowColumns)) {
          columns = rowColumns;
        } else {
          columns = fieldsInRow.length;
        }

        const fieldCount = seenFields.get(fieldName) || 0;
        seenFields.set(fieldName, fieldCount + 1);

        return (
          <SectionFields_Box_1
            key={fieldCount === 0 ? fieldName : `${fieldName}-${fieldCount}`}
            style={{ '--w-md': (100 / columns).toFixed(2) + '%' }}
          >
            <SectionField fields={fields} field={fieldName} />
          </SectionFields_Box_1>
        );
      })}
    </div>
  );
}
